import { ShowColumnsFilter } from "@/components/ColumnMenu";
import { ActionCellPopupSettings } from "@/components/custom-cells";
import { IUserGroup } from "@/interfaces/userGroup.interface";
import { MIN_RESIZABLE_WIDTH_KENDO_TABLE } from "@/utils/kendo";
import { Switch } from "@progress/kendo-react-inputs";

export interface columnInterface {
  title?: string;
  field?: string;
  show?: boolean;
  filter?: "boolean" | "numeric" | "text" | "date" | undefined;
  minWidth?: number;
  minGridWidth?: number;
  locked?: boolean;
  width?: string | number;
  columnMenu?: any;
  minResizableWidth?: number;
  cells?: any;
}

export const generateColumns = (
  handleEditClick: any,
  onColumnsSubmit: any,
  columnsExternal?: any,
  enableDisableUserGroup?: (dataItem: IUserGroup) => void
): any => {
  const columns = [
    {
      title: "Name",
      field: "name",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <ActionCellPopupSettings
            rowData={props.dataItem}
            handleEditClick={handleEditClick}
            dataKey="name"
          />
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Active",
      field: "isActive",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <td>
            <Switch
              checked={props.dataItem.isActive}
              defaultChecked={props.dataItem.isActive}
              onLabel="Yes"
              offLabel="No"
              onChange={() => enableDisableUserGroup?.(props.dataItem)}
              name="isActive"
            />
          </td>
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
  ];

  if (columnsExternal) {
    return columnsExternal;
  }

  return columns;
};
